import {useTranslation} from "react-i18next";

const Warranty = () => {

    const { t } = useTranslation();

    return (
        <>
            <div>
                <h4>{t("serviceDetailPage.garanzia-splendida.contentTitle1")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText1") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText2") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText3") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText4") as string }}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.garanzia-splendida.contentTitle2")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText5") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText6") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText7") as string }}></p>
                <ul>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem1")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem2")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem3")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem4")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem5")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem6")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem7")}</li>
                    <li>{t("serviceDetailPage.garanzia-splendida.listItem8")}</li>
                </ul>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText8") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText9") as string }}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.garanzia-splendida.contentTitle3")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText10") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText11") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText12") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText13") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText14") as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.garanzia-splendida.contentText15") as string }}></p>
            </div>
        </>
    )
}

export default Warranty;